import { get } from "./helpers";

export const fetchSelfHostAgency = async () => {
  const result = await get("/api/host-agency");
  return result.data;
};
